import { useEffect } from 'react'
import { LandingNav } from './LandingNav'
import { Hero } from './Hero'
import { Features } from './Features'
import { About } from './About'
import { Showcase } from './Showcase'
import { HowItWorks } from './HowItWorks'
import { Community } from './Community'
import { Footer } from './Footer'
import styles from './WelcomePage.module.css'

export function WelcomePage() {
  // Allow scrolling on the welcome page (body has overflow:hidden for editor)
  useEffect(() => {
    document.title = 'Fantasy Console 0 - Make games with JavaScript'
    document.body.style.overflow = 'auto'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className={styles.page}>
      <LandingNav />
      <Hero />
      <Features />
      <About />
      <Showcase />
      {/* <HowItWorks /> */}
      {/* <Community /> */}
      <Footer />
    </div>
  )
}
